import { status, StatusType } from '../../typeStatus'
import { HealthStatusResDto } from '../interface'

export const GET_HEALTH_STATUS_BUMI_SERVICE = 'GET_HEALTH_STATUS_BUMI_SERVICE'
export const GET_HEALTH_STATUS_BUMI_SERVICE_SUCCESS = 'GET_HEALTH_STATUS_BUMI_SERVICE_SUCCESS'
export const GET_HEALTH_STATUS_BUMI_SERVICE_ERROR = 'GET_HEALTH_STATUS_BUMI_SERVICE_ERROR'

export const InitialState: HealthStatusState = {
  status: status.initial,
  response: null,
}

export interface HealthStatusState {
  status: StatusType
  response: HealthStatusResDto | null
}

export interface GetHealthStatus {
  type: typeof GET_HEALTH_STATUS_BUMI_SERVICE
  payload: null
}

export interface GetHealthStatusSuccess {
  type: typeof GET_HEALTH_STATUS_BUMI_SERVICE_SUCCESS
  payload: HealthStatusResDto
}
export interface GetHealthStatusError {
  type: typeof GET_HEALTH_STATUS_BUMI_SERVICE_ERROR
  payload: null
}

export type HealthStatusActions = GetHealthStatus | GetHealthStatusSuccess | GetHealthStatusError
